export { CheckoutStatus } from "@comparaonline/cicl-funnel-schema";

export const FINESA_INSTALLMENTS_COUNT = 11;
export const MAIN_COLLECTION = "cico-funnel";
export const OFFER_COLLECTION = "offer";
export const QUOTE_COLLECTION = "quote";
export const LOGIN = "login";
export const REQUOTE = "requote";
export const DIGITAL_SIGNATURE = "digital-signature";
export const SARLAFT_SIGNATURE_NOT_REQUIRED_IN_RENEWALS_PA_CODE =
  "no-signature-in-sarlaft-renewals";
export const REQUIRE_CAR_INFORMATION_PA_CODE = "require-car-information";
export const CIIU_CODE_OPTIONS = [
  { value: "0010", label: "Asalariados" },
  { value: "0081", label: "Personas Naturales sin Actividad Económica" },
  { value: "0082", label: "Personas Naturales Subsidiadas por Terceros" },
  { value: "0090", label: "Rentistas de Capital, solo para personas naturales" },
  { value: "0111", label: "Cultivo de cereales (excepto arroz), legumbres y semillas oleaginosas" },
  { value: "0112", label: "Cultivo de arroz" },
  { value: "0113", label: "Cultivo de hortalizas, raíces y tubérculos" },
  { value: "0114", label: "Cultivo de tabaco" },
  { value: "0115", label: "Cultivo de plantas textiles" },
  { value: "0119", label: "Otros cultivos transitorios n.c.p." },
  { value: "0121", label: "Cultivo de frutas tropicales y subtropicales" },
  { value: "0122", label: "Cultivo de plátano y banano" },
  { value: "0123", label: "Cultivo de café" },
  { value: "0124", label: "Cultivo de caña de azúcar" },
  { value: "0125", label: "Cultivo de flor de corte" },
  {
    value: "0126",
    label: "Cultivo de palma para aceite (palma africana) y otros frutos oleaginosos"
  },
  { value: "0127", label: "Cultivo de plantas con las que se preparan bebidas" },
  { value: "0128", label: "Cultivo de especias y de plantas aromáticas y medicinales" },
  { value: "0129", label: "Otros cultivos permanentes n.c.p." },
  {
    value: "0130",
    label: "Propagación de plantas (actividades de los viveros, excepto viveros forestales)"
  },
  { value: "0141", label: "Cría de ganado bovino y bufalino" },
  { value: "0142", label: "Cría de caballos y otros equinos" },
  { value: "0143", label: "Cría de ovejas y cabras" },
  { value: "0144", label: "Cría de ganado porcino" },
  { value: "0145", label: "Cría de aves de corral" },
  { value: "0149", label: "Cría de otros animales n.c.p." },
  { value: "0150", label: "Explotación mixta (agrícola y pecuaria)" },
  { value: "0161", label: "Actividades de apoyo a la agricultura" },
  { value: "0162", label: "Actividades de apoyo a la ganadería" },
  { value: "0163", label: "Actividades posteriores a la cosecha" },
  { value: "0164", label: "Tratamiento de semillas para propagación" },
  { value: "0170", label: "Caza ordinaria y mediante trampas y actividades de servicios conexas" },
  { value: "0210", label: "Silvicultura y otras actividades forestales" },
  { value: "0220", label: "Extracción de madera" },
  { value: "0230", label: "Recolección de productos forestales diferentes a la madera" },
  { value: "0240", label: "Servicios de apoyo a la silvicultura" },
  { value: "0311", label: "Pesca marítima" },
  { value: "0312", label: "Pesca de agua dulce" },
  { value: "0321", label: "Acuicultura marítima" },
  { value: "0322", label: "Acuicultura de agua dulce" },
  { value: "0510", label: "Extracción de hulla (carbón de piedra)" },
  { value: "0520", label: "Extracción de carbón lignito" },
  { value: "0610", label: "Extracción de petróleo crudo" },
  { value: "0620", label: "Extracción de gas natural" },
  { value: "0710", label: "Extracción de minerales de hierro" },
  { value: "0721", label: "Extracción de minerales de uranio y de torio" },
  { value: "0722", label: "Extracción de oro y otros metales preciosos" },
  { value: "0723", label: "Extracción de minerales de níquel" },
  { value: "0729", label: "Extracción de otros minerales metalíferos no ferrosos n.c.p." },
  { value: "0811", label: "Extracción de piedra, arena, arcillas comunes, yeso y anhidrita" },
  { value: "0812", label: "Extracción de arcillas de uso industrial, caliza, caolín y bentonitas" },
  { value: "0820", label: "Extracción de esmeraldas, piedras preciosas y semipreciosas" },
  {
    value: "0891",
    label: "Extracción de minerales para la fabricación de abonos y productos químicos"
  },
  { value: "0892", label: "Extracción de halita (sal)" },
  { value: "0899", label: "Extracción de otros minerales no metálicos n.c.p." },
  { value: "0910", label: "Actividades de apoyo para la extracción de petróleo y de gas natural" },
  {
    value: "0990",
    label: "Actividades de apoyo para otras actividades de explotación de minas y canteras"
  },
  { value: "1011", label: "Procesamiento y conservación de carne y productos cárnicos" },
  { value: "1012", label: "Procesamiento y conservación de pescados, crustáceos y moluscos" },
  {
    value: "1020",
    label: "Procesamiento y conservación de frutas, legumbres, hortalizas y tubérculos"
  },
  { value: "1030", label: "Elaboración de aceites y grasas de origen vegetal y animal" },
  { value: "1040", label: "Elaboración de productos lácteos" },
  { value: "1051", label: "Elaboración de productos de molinería" },
  { value: "1052", label: "Elaboración de almidones y productos derivados del almidón" },
  { value: "1061", label: "Trilla de café" },
  { value: "1062", label: "Descafeinado, tostión y molienda del café" },
  { value: "1063", label: "Otros derivados del café" },
  { value: "1071", label: "Elaboración y refinación de azúcar" },
  { value: "1072", label: "Elaboración de panela" },
  { value: "1081", label: "Elaboración de productos de panadería" },
  { value: "1082", label: "Elaboración de cacao, chocolate y productos de confitería" },
  {
    value: "1083",
    label: "Elaboración de macarrones, fideos, alcuzcuz y productos farináceos similares"
  },
  { value: "1084", label: "Elaboración de comidas y platos preparados" },
  { value: "1089", label: "Elaboración de otros productos alimenticios n.c.p." },
  { value: "1090", label: "Elaboración de alimentos preparados para animales" },
  { value: "1101", label: "Destilación, rectificación y mezcla de bebidas alcohólicas" },
  { value: "1102", label: "Elaboración de bebidas fermentadas no destiladas" },
  {
    value: "1103",
    label: "Producción de malta, elaboración de cervezas y otras bebidas malteadas"
  },
  {
    value: "1104",
    label:
      "Elaboración de bebidas no alcohólicas, producción de aguas minerales y de otras aguas embotelladas"
  },
  { value: "1200", label: "Elaboración de productos de tabaco" },
  { value: "1311", label: "Preparación e hilatura de fibras textiles" },
  { value: "1312", label: "Tejeduría de productos textiles" },
  { value: "1313", label: "Acabado de productos textiles" },
  { value: "1391", label: "Fabricación de tejidos de punto y ganchillo" },
  {
    value: "1392",
    label: "Confección de artículos con materiales textiles, excepto prendas de vestir"
  },
  { value: "1393", label: "Fabricación de tapetes y alfombras para pisos" },
  { value: "1394", label: "Fabricación de cuerdas, cordeles, cables, bramantes y redes" },
  { value: "1399", label: "Fabricación de otros artículos textiles n.c.p." },
  { value: "1410", label: "Confección de prendas de vestir, excepto prendas de piel" },
  { value: "1420", label: "Fabricación de artículos de piel" },
  { value: "1430", label: "Fabricación de artículos de punto y ganchillo" },
  { value: "1511", label: "Curtido y recurtido de cueros; recurtido y teñido de pieles" },
  {
    value: "1512",
    label:
      "Fabricación de artículos de viaje, bolsos de mano y artículos similares elaborados en cuero, y fabricación de artículos de talabartería y guarnicionería"
  },
  {
    value: "1513",
    label:
      "Fabricación de artículos de viaje, bolsos de mano y artículos similares; artículos de talabartería y guarnicionería elaborados en otros materiales"
  },
  { value: "1521", label: "Fabricación de calzado de cuero y piel, con cualquier tipo de suela" },
  {
    value: "1522",
    label: "Fabricación de otros tipos de calzado, excepto calzado de cuero y piel"
  },
  { value: "1523", label: "Fabricación de partes del calzado" },
  { value: "1610", label: "Aserrado, acepillado e impregnación de la madera" },
  {
    value: "1620",
    label:
      "Fabricación de hojas de madera para enchapado; fabricación de tableros contrachapados, tableros laminados, tableros de partículas y otros tableros y paneles"
  },
  {
    value: "1630",
    label:
      "Fabricación de partes y piezas de madera, de carpintería y ebanistería para la construcción"
  },
  { value: "1640", label: "Fabricación de recipientes de madera" },
  {
    value: "1690",
    label:
      "Fabricación de otros productos de madera; fabricación de artículos de corcho, cestería y espartería"
  },
  { value: "1701", label: "Fabricación de pulpas (pastas) celulósicas; papel y cartón" },
  {
    value: "1702",
    label:
      "Fabricación de papel y cartón ondulado (corrugado); fabricación de envases, empaques y de embalajes de papel y cartón."
  },
  { value: "1709", label: "Fabricación de otros artículos de papel y cartón" },
  { value: "1811", label: "Actividades de impresión" },
  { value: "1812", label: "Actividades de servicios relacionados con la impresión" },
  { value: "1820", label: "Producción de copias a partir de grabaciones originales" },
  { value: "1910", label: "Fabricación de productos de hornos de coque" },
  { value: "1921", label: "Fabricación de productos de la refinación del petróleo" },
  { value: "1922", label: "Actividad de mezcla de combustibles" },
  { value: "2011", label: "Fabricación de sustancias y productos químicos básicos" },
  { value: "2012", label: "Fabricación de abonos y compuestos inorgánicos nitrogenados" },
  { value: "2013", label: "Fabricación de plásticos en formas primarias" },
  { value: "2014", label: "Fabricación de caucho sintético en formas primarias" },
  {
    value: "2021",
    label: "Fabricación de plaguicidas y otros productos químicos de uso agropecuario"
  },
  {
    value: "2022",
    label:
      "Fabricación de pinturas, barnices y revestimientos similares, tintas para impresión y masillas"
  },
  {
    value: "2023",
    label:
      "Fabricación de jabones y detergentes, preparados para limpiar y pulir; perfumes y preparados de tocador"
  },
  { value: "2029", label: "Fabricación de otros productos químicos n.c.p." },
  { value: "2030", label: "Fabricación de fibras sintéticas y artificiales" },
  {
    value: "2100",
    label:
      "Fabricación de productos farmacéuticos, sustancias químicas medicinales y productos botánicos de uso farmacéutico"
  },
  { value: "2211", label: "Fabricación de llantas y neumáticos de caucho" },
  { value: "2212", label: "Reencauche de llantas usadas" },
  {
    value: "2219",
    label: "Fabricación de formas básicas de caucho y otros productos de caucho n.c.p."
  },
  { value: "2221", label: "Fabricación de formas básicas de plástico" },
  { value: "2229", label: "Fabricación de artículos de plástico n.c.p." },
  { value: "2310", label: "Fabricación de vidrio y productos de vidrio" },
  { value: "2391", label: "Fabricación de productos refractarios" },
  { value: "2392", label: "Fabricación de materiales de arcilla para la construcción" },
  { value: "2393", label: "Fabricación de otros productos de cerámica y porcelana" },
  { value: "2394", label: "Fabricación de cemento, cal y yeso" },
  { value: "2395", label: "Fabricación de artículos de hormigón, cemento y yeso" },
  { value: "2396", label: "Corte, tallado y acabado de la piedra" },
  { value: "2399", label: "Fabricación de otros productos minerales no metálicos n.c.p." },
  { value: "2410", label: "Industrias básicas de hierro y de acero" },
  { value: "2421", label: "Industrias básicas de metales preciosos" },
  { value: "2429", label: "Industrias básicas de otros metales no ferrosos" },
  { value: "2431", label: "Fundición de hierro y de acero" },
  { value: "2432", label: "Fundición de metales no ferrosos" },
  { value: "2511", label: "Fabricación de productos metálicos para uso estructural" },
  {
    value: "2512",
    label:
      "Fabricación de tanques, depósitos y recipientes de metal, excepto los utilizados para el envase o transporte de mercancías"
  },
  {
    value: "2513",
    label:
      "Fabricación de generadores de vapor, excepto calderas de agua caliente para calefacción central"
  },
  { value: "2520", label: "Fabricación de armas y municiones" },
  { value: "2591", label: "Forja, prensado, estampado y laminado de metal; pulvimetalurgia" },
  { value: "2592", label: "Tratamiento y revestimiento de metales; mecanizado" },
  {
    value: "2593",
    label: "Fabricación de artículos de cuchillería, herramientas de mano y artículos de ferretería"
  },
  { value: "2599", label: "Fabricación de otros productos elaborados de metal n.c.p." },
  { value: "2610", label: "Fabricación de componentes y tableros electrónicos" },
  { value: "2620", label: "Fabricación de computadoras y de equipo periférico" },
  { value: "2630", label: "Fabricación de equipos de comunicación" },
  { value: "2640", label: "Fabricación de aparatos electrónicos de consumo" },
  { value: "2651", label: "Fabricación de equipo de medición, prueba, navegación y control" },
  { value: "2652", label: "Fabricación de relojes" },
  {
    value: "2660",
    label: "Fabricación de equipo de irradiación y equipo electrónico de uso médico y terapéutico"
  },
  { value: "2670", label: "Fabricación de instrumentos ópticos y equipo fotográfico" },
  {
    value: "2680",
    label: "Fabricación de medios magnéticos y ópticos para almacenamiento de datos"
  },
  { value: "2711", label: "Fabricación de motores, generadores y transformadores eléctricos" },
  {
    value: "2712",
    label: "Fabricación de aparatos de distribución y control de la energía eléctrica"
  },
  { value: "2720", label: "Fabricación de pilas, baterías y acumuladores eléctricos" },
  { value: "2731", label: "Fabricación de hilos y cables eléctricos y de fibra óptica" },
  { value: "2732", label: "Fabricación de dispositivos de cableado" },
  { value: "2740", label: "Fabricación de equipos eléctricos de iluminación" },
  { value: "2750", label: "Fabricación de aparatos de uso doméstico" },
  { value: "2790", label: "Fabricación de otros tipos de equipo eléctrico n.c.p." },
  {
    value: "2811",
    label: "Fabricación de motores, turbinas, y partes para motores de combustión interna"
  },
  { value: "2812", label: "Fabricación de equipos de potencia hidráulica y neumática" },
  { value: "2813", label: "Fabricación de otras bombas, compresores, grifos y válvulas" },
  {
    value: "2814",
    label: "Fabricación de cojinetes, engranajes, trenes de engranajes y piezas de transmisión"
  },
  { value: "2815", label: "Fabricación de hornos, hogares y quemadores industriales" },
  { value: "2816", label: "Fabricación de equipo de elevación y manipulación" },
  {
    value: "2817",
    label:
      "Fabricación de maquinaria y equipo de oficina (excepto computadoras y equipo periférico)"
  },
  { value: "2818", label: "Fabricación de herramientas manuales con motor" },
  {
    value: "2819",
    label: "Fabricación de otros tipos de maquinaria y equipo de uso general n.c.p."
  },
  { value: "2821", label: "Fabricación de maquinaria agropecuaria y forestal" },
  { value: "2822", label: "Fabricación de máquinas formadoras de metal y de máquinas herramienta" },
  { value: "2823", label: "Fabricación de maquinaria para la metalurgia" },
  {
    value: "2824",
    label:
      "Fabricación de maquinaria para explotación de minas y canteras y para obras de construcción"
  },
  {
    value: "2825",
    label: "Fabricación de maquinaria para la elaboración de alimentos, bebidas y tabaco"
  },
  {
    value: "2826",
    label:
      "Fabricación de maquinaria para la elaboración de productos textiles, prendas de vestir y cueros"
  },
  {
    value: "2829",
    label: "Fabricación de otros tipos de maquinaria y equipo de uso especial n.c.p."
  },
  { value: "2910", label: "Fabricación de vehículos automotores y sus motores" },
  {
    value: "2920",
    label:
      "Fabricación de carrocerías para vehículos automotores; fabricación de remolques y semirremolques"
  },
  {
    value: "2930",
    label:
      "Fabricación de partes, piezas (autopartes) y accesorios (lujos) para vehículos automotores"
  },
  { value: "3011", label: "Construcción de barcos y de estructuras flotantes" },
  { value: "3012", label: "Construcción de embarcaciones de recreo y deporte" },
  { value: "3020", label: "Fabricación de locomotoras y de material rodante para ferrocarriles" },
  { value: "3030", label: "Fabricación de aeronaves, naves espaciales y de maquinaria conexa" },
  { value: "3040", label: "Fabricación de vehículos militares de combate" },
  { value: "3091", label: "Fabricación de motocicletas" },
  {
    value: "3092",
    label: "Fabricación de bicicletas y de sillas de ruedas para personas con discapacidad"
  },
  { value: "3099", label: "Fabricación de otros tipos de equipo de transporte n.c.p." },
  { value: "3110", label: "Fabricación de muebles" },
  { value: "3120", label: "Fabricación de colchones y somieres" },
  { value: "3210", label: "Fabricación de joyas, bisutería y artículos conexos" },
  { value: "3220", label: "Fabricación de instrumentos musicales" },
  { value: "3230", label: "Fabricación de artículos y equipo para la práctica del deporte" },
  { value: "3240", label: "Fabricación de juegos, juguetes y rompecabezas" },
  {
    value: "3250",
    label:
      "Fabricación de instrumentos, aparatos y materiales médicos y odontológicos (incluido mobiliario)"
  },
  { value: "3290", label: "Otras industrias manufactureras n.c.p." },
  {
    value: "3311",
    label: "Mantenimiento y reparación especializado de productos elaborados en metal"
  },
  { value: "3312", label: "Mantenimiento y reparación especializado de maquinaria y equipo" },
  {
    value: "3313",
    label: "Mantenimiento y reparación especializado de equipo electrónico y óptico"
  },
  { value: "3314", label: "Mantenimiento y reparación especializado de equipo eléctrico" },
  {
    value: "3315",
    label:
      "Mantenimiento y reparación especializado de equipo de transporte, excepto los vehículos automotores, motocicletas y bicicletas"
  },
  {
    value: "3319",
    label: "Mantenimiento y reparación de otros tipos de equipos y sus componentes n.c.p."
  },
  { value: "3320", label: "Instalación especializada de maquinaria y equipo industrial" },
  { value: "3511", label: "Generación de energía eléctrica" },
  { value: "3512", label: "Transmisión de energía eléctrica" },
  { value: "3513", label: "Distribución de energía eléctrica" },
  { value: "3514", label: "Comercialización de energía eléctrica" },
  { value: "3520", label: "Producción de gas; distribución de combustibles gaseosos por tuberías" },
  { value: "3530", label: "Suministro de vapor y aire acondicionado" },
  { value: "3600", label: "Captación, tratamiento y distribución de agua" },
  { value: "3700", label: "Evacuación y tratamiento de aguas residuales" },
  { value: "3811", label: "Recolección de desechos no peligrosos" },
  { value: "3812", label: "Recolección de desechos peligrosos" },
  { value: "3821", label: "Tratamiento y disposición de desechos no peligrosos" },
  { value: "3822", label: "Tratamiento y disposición de desechos peligrosos" },
  { value: "3830", label: "Recuperación de materiales" },
  {
    value: "3900",
    label: "Actividades de saneamiento ambiental y otros servicios de gestión de desechos"
  },
  { value: "4111", label: "Construcción de edificios residenciales" },
  { value: "4112", label: "Construcción de edificios no residenciales" },
  { value: "4210", label: "Construcción de carreteras y vías de ferrocarril" },
  { value: "4220", label: "Construcción de proyectos de servicio público" },
  { value: "4290", label: "Construcción de otras obras de ingeniería civil" },
  { value: "4311", label: "Demolición" },
  { value: "4312", label: "Preparación del terreno" },
  { value: "4321", label: "Instalaciones eléctricas" },
  { value: "4322", label: "Instalaciones de fontanería, calefacción y aire acondicionado" },
  { value: "4329", label: "Otras instalaciones especializadas" },
  { value: "4330", label: "Terminación y acabado de edificios y obras de ingeniería civil" },
  {
    value: "4390",
    label:
      "Otras actividades especializadas para la construcción de edificios y obras de ingeniería civil"
  },
  { value: "4511", label: "Comercio de vehículos automotores nuevos" },
  { value: "4512", label: "Comercio de vehículos automotores usados" },
  { value: "4520", label: "Mantenimiento y reparación de vehículos automotores" },
  {
    value: "4530",
    label: "Comercio de partes, piezas (autopartes) y accesorios (lujos) para vehículos automotores"
  },
  { value: "4541", label: "Comercio de motocicletas y de sus partes, piezas y accesorios" },
  { value: "4542", label: "Mantenimiento y reparación de motocicletas y de sus partes y piezas" },
  { value: "4610", label: "Comercio al por mayor a cambio de una retribución o por contrata" },
  {
    value: "4620",
    label: "Comercio al por mayor de materias primas agropecuarias; animales vivos"
  },
  { value: "4631", label: "Comercio al por mayor de productos alimenticios" },
  { value: "4632", label: "Comercio al por mayor de bebidas y tabaco" },
  {
    value: "4641",
    label:
      "Comercio al por mayor de productos textiles, productos confeccionados para uso doméstico"
  },
  { value: "4642", label: "Comercio al por mayor de prendas de vestir" },
  { value: "4643", label: "Comercio al por mayor de calzado" },
  { value: "4644", label: "Comercio al por mayor de aparatos y equipo de uso doméstico" },
  {
    value: "4645",
    label: "Comercio al por mayor de productos farmacéuticos, medicinales, cosméticos y de tocador"
  },
  { value: "4649", label: "Comercio al por mayor de otros utensilios domésticos n.c.p." },
  {
    value: "4651",
    label: "Comercio al por mayor de computadores, equipo periférico y programas de informática"
  },
  {
    value: "4652",
    label: "Comercio al por mayor de equipo, partes y piezas electrónicos y de telecomunicaciones"
  },
  { value: "4653", label: "Comercio al por mayor de maquinaria y equipo agropecuarios" },
  { value: "4659", label: "Comercio al por mayor de otros tipos de maquinaria y equipo n.c.p." },
  {
    value: "4661",
    label: "Comercio al por mayor de combustibles sólidos, líquidos, gaseosos y productos conexos"
  },
  { value: "4662", label: "Comercio al por mayor de metales y productos metalíferos" },
  {
    value: "4663",
    label:
      "Comercio al por mayor de materiales de construcción, artículos de ferretería, pinturas, productos de vidrio, equipo y materiales de fontanería y calefacción"
  },
  {
    value: "4664",
    label:
      "Comercio al por mayor de productos químicos básicos, cauchos y plásticos en formas primarias y productos químicos de uso agropecuario"
  },
  { value: "4665", label: "Comercio al por mayor de desperdicios, desechos y chatarra" },
  { value: "4669", label: "Comercio al por mayor de otros productos n.c.p." },
  { value: "4690", label: "Comercio al por mayor no especializado" },
  {
    value: "4711",
    label:
      "Comercio al por menor en establecimientos no especializados con surtido compuesto principalmente por alimentos, bebidas o tabaco"
  },
  {
    value: "4719",
    label:
      "Comercio al por menor en establecimientos no especializados, con surtido compuesto principalmente por productos diferentes de alimentos (víveres en general), bebidas y tabaco"
  },
  {
    value: "4721",
    label:
      "Comercio al por menor de productos agrícolas para el consumo en establecimientos especializados"
  },
  {
    value: "4722",
    label:
      "Comercio al por menor de leche, productos lácteos y huevos, en establecimientos especializados"
  },
  {
    value: "4723",
    label:
      "Comercio al por menor de carnes (incluye aves de corral), productos cárnicos, pescados y productos de mar, en establecimientos especializados"
  },
  {
    value: "4724",
    label:
      "Comercio al por menor de bebidas y productos del tabaco, en establecimientos especializados"
  },
  {
    value: "4729",
    label:
      "Comercio al por menor de otros productos alimenticios n.c.p., en establecimientos especializados"
  },
  { value: "4731", label: "Comercio al por menor de combustible para automotores" },
  {
    value: "4732",
    label:
      "Comercio al por menor de lubricantes (aceites, grasas), aditivos y productos de limpieza para vehículos automotores"
  },
  {
    value: "4741",
    label:
      "Comercio al por menor de computadores, equipos periféricos, programas de informática y equipos de telecomunicaciones en establecimientos especializados"
  },
  {
    value: "4742",
    label:
      "Comercio al por menor de equipos y aparatos de sonido y de video, en establecimientos especializados"
  },
  {
    value: "4751",
    label: "Comercio al por menor de productos textiles en establecimientos especializados"
  },
  {
    value: "4752",
    label:
      "Comercio al por menor de artículos de ferretería, pinturas y productos de vidrio en establecimientos especializados"
  },
  {
    value: "4753",
    label:
      "Comercio al por menor de tapices, alfombras y cubrimientos para paredes y pisos en establecimientos especializados"
  },
  {
    value: "4754",
    label:
      "Comercio al por menor de electrodomésticos y gasodomésticos de uso doméstico, muebles y equipos de iluminación"
  },
  { value: "4755", label: "Comercio al por menor de artículos y utensilios de uso doméstico" },
  {
    value: "4759",
    label: "Comercio al por menor de otros artículos domésticos en establecimientos especializados"
  },
  {
    value: "4761",
    label:
      "Comercio al por menor de libros, periódicos, materiales y artículos de papelería y escritorio, en establecimientos especializados"
  },
  {
    value: "4762",
    label: "Comercio al por menor de artículos deportivos, en establecimientos especializados"
  },
  {
    value: "4769",
    label:
      "Comercio al por menor de otros artículos culturales y de entretenimiento n.c.p. en establecimientos especializados"
  },
  {
    value: "4771",
    label:
      "Comercio al por menor de prendas de vestir y sus accesorios (incluye artículos de piel) en establecimientos especializados"
  },
  {
    value: "4772",
    label:
      "Comercio al por menor de todo tipo de calzado y artículos de cuero y sucedáneos del cuero en establecimientos especializados."
  },
  {
    value: "4773",
    label:
      "Comercio al por menor de productos farmacéuticos y medicinales, cosméticos y artículos de tocador en establecimientos especializados"
  },
  {
    value: "4774",
    label: "Comercio al por menor de otros productos nuevos en establecimientos especializados"
  },
  { value: "4775", label: "Comercio al por menor de artículos de segunda mano" },
  {
    value: "4781",
    label: "Comercio al por menor de alimentos, bebidas y tabaco, en puestos de venta móviles"
  },
  {
    value: "4782",
    label:
      "Comercio al por menor de productos textiles, prendas de vestir y calzado, en puestos de venta móviles"
  },
  { value: "4789", label: "Comercio al por menor de otros productos en puestos de venta móviles" },
  { value: "4791", label: "Comercio al por menor realizado a través de Internet" },
  {
    value: "4792",
    label: "Comercio al por menor realizado a través de casas de venta o por correo"
  },
  {
    value: "4799",
    label:
      "Otros tipos de comercio al por menor no realizado en establecimientos, puestos de venta o mercados."
  },
  { value: "4911", label: "Transporte férreo de pasajeros" },
  { value: "4912", label: "Transporte férreo de carga" },
  { value: "4921", label: "Transporte de pasajeros" },
  { value: "4922", label: "Transporte mixto" },
  { value: "4923", label: "Transporte de carga por carretera" },
  { value: "4930", label: "Transporte por tuberías" },
  { value: "5011", label: "Transporte de pasajeros marítimo y de cabotaje" },
  { value: "5012", label: "Transporte de carga marítimo y de cabotaje" },
  { value: "5021", label: "Transporte fluvial de pasajeros" },
  { value: "5022", label: "Transporte fluvial de carga" },
  { value: "5111", label: "Transporte aéreo nacional de pasajeros" },
  { value: "5112", label: "Transporte aéreo internacional de pasajeros" },
  { value: "5121", label: "Transporte aéreo nacional de carga" },
  { value: "5122", label: "Transporte aéreo internacional de carga" },
  { value: "5210", label: "Almacenamiento y depósito" },
  {
    value: "5221",
    label:
      "Actividades de estaciones, vías y servicios complementarios para el transporte terrestre"
  },
  {
    value: "5222",
    label: "Actividades de puertos y servicios complementarios para el transporte acuático"
  },
  {
    value: "5223",
    label:
      "Actividades de aeropuertos, servicios de navegación aérea y demás actividades conexas al transporte aéreo"
  },
  { value: "5224", label: "Manipulación de carga" },
  { value: "5229", label: "Otras actividades complementarias al transporte" },
  { value: "5310", label: "Actividades postales nacionales" },
  { value: "5320", label: "Actividades de mensajería" },
  { value: "5511", label: "Alojamiento en hoteles" },
  { value: "5512", label: "Alojamiento en apartahoteles" },
  { value: "5513", label: "Alojamiento en centros vacacionales" },
  { value: "5514", label: "Alojamiento rural" },
  { value: "5519", label: "Otros tipos de alojamientos para visitantes" },
  {
    value: "5520",
    label: "Actividades de zonas de camping y parques para vehículos recreacionales"
  },
  { value: "5530", label: "Servicio por horas" },
  { value: "5590", label: "Otros tipos de alojamiento n.c.p." },
  { value: "5611", label: "Expendio a la mesa de comidas preparadas" },
  { value: "5612", label: "Expendio por autoservicio de comidas preparadas" },
  { value: "5613", label: "Expendio de comidas preparadas en cafeterías" },
  { value: "5619", label: "Otros tipos de expendio de comidas preparadas n.c.p." },
  { value: "5621", label: "Catering para eventos" },
  { value: "5629", label: "Actividades de otros servicios de comidas" },
  {
    value: "5630",
    label: "Expendio de bebidas alcohólicas para el consumo dentro del establecimiento"
  },
  { value: "5811", label: "Edición de libros" },
  { value: "5812", label: "Edición de directorios y listas de correo" },
  { value: "5813", label: "Edición de periódicos, revistas y otras publicaciones periódicas" },
  { value: "5819", label: "Otros trabajos de edición" },
  { value: "5820", label: "Edición de programas de informática (software)" },
  {
    value: "5911",
    label:
      "Actividades de producción de películas cinematográficas, videos, programas, anuncios y comerciales de televisión"
  },
  {
    value: "5912",
    label:
      "Actividades de posproducción de películas cinematográficas, videos, programas, anuncios y comerciales de televisión"
  },
  {
    value: "5913",
    label:
      "Actividades de distribución de películas cinematográficas, videos, programas, anuncios y comerciales de televisión"
  },
  { value: "5914", label: "Actividades de exhibición de películas cinematográficas y videos" },
  { value: "5920", label: "Actividades de grabación de sonido y edición de música" },
  {
    value: "6010",
    label: "Actividades de programación y transmisión en el servicio de radiodifusión sonora"
  },
  { value: "6020", label: "Actividades de programación y transmisión de televisión" },
  { value: "6110", label: "Actividades de telecomunicaciones alámbricas" },
  { value: "6120", label: "Actividades de telecomunicaciones inalámbricas" },
  { value: "6130", label: "Actividades de telecomunicación satelital" },
  { value: "6190", label: "Otras actividades de telecomunicaciones" },
  {
    value: "6201",
    label:
      "Actividades de desarrollo de sistemas informáticos (planificación, análisis, diseño, programación, pruebas)"
  },
  {
    value: "6202",
    label:
      "Actividades de consultoría informática y actividades de administración de instalaciones informáticas"
  },
  {
    value: "6209",
    label: "Otras actividades de tecnologías de información y actividades de servicios informáticos"
  },
  {
    value: "6311",
    label: "Procesamiento de datos, alojamiento (hosting) y actividades relacionadas"
  },
  { value: "6312", label: "Portales web" },
  { value: "6391", label: "Actividades de agencias de noticias" },
  { value: "6399", label: "Otras actividades de servicio de información n.c.p." },
  { value: "6411", label: "Banco Central" },
  { value: "6412", label: "Bancos comerciales" },
  { value: "6421", label: "Actividades de las corporaciones financieras" },
  { value: "6422", label: "Actividades de las compañías de financiamiento" },
  { value: "6423", label: "Banca de segundo piso" },
  { value: "6424", label: "Actividades de las cooperativas financieras" },
  { value: "6431", label: "Fideicomisos, fondos y entidades financieras similares" },
  { value: "6432", label: "Fondos de cesantías" },
  { value: "6491", label: "Leasing financiero (arrendamiento financiero)" },
  {
    value: "6492",
    label:
      "Actividades financieras de fondos de empleados y otras formas asociativas del sector solidario"
  },
  { value: "6493", label: "Actividades de compra de cartera o factoring" },
  { value: "6494", label: "Otras actividades de distribución de fondos" },
  { value: "6495", label: "Instituciones especiales oficiales" },
  {
    value: "6499",
    label: "Otras actividades de servicio financiero, excepto las de seguros y pensiones n.c.p."
  },
  { value: "6511", label: "Seguros generales" },
  { value: "6512", label: "Seguros de vida" },
  { value: "6513", label: "Reaseguros" },
  { value: "6514", label: "Capitalización" },
  { value: "6521", label: "Servicios de seguros sociales de salud" },
  { value: "6522", label: "Servicios de seguros sociales de riesgos profesionales" },
  { value: "6531", label: "Régimen de prima media con prestación definida (RPM)" },
  { value: "6532", label: "Régimen de ahorro individual (RAI)" },
  { value: "6611", label: "Administración de mercados financieros" },
  { value: "6612", label: "Corretaje de valores y de contratos de productos básicos" },
  { value: "6613", label: "Otras actividades relacionadas con el mercado de valores" },
  { value: "6614", label: "Actividades de las casas de cambio" },
  { value: "6615", label: "Actividades de los profesionales de compra y venta de divisas" },
  {
    value: "6619",
    label: "Otras actividades auxiliares de las actividades de servicios financieros n.c.p."
  },
  { value: "6621", label: "Actividades de agentes y corredores de seguros" },
  {
    value: "6629",
    label: "Evaluación de riesgos y daños, y otras actividades de servicios auxiliares"
  },
  { value: "6630", label: "Actividades de administración de fondos" },
  { value: "6810", label: "Actividades inmobiliarias realizadas con bienes propios o arrendados" },
  {
    value: "6820",
    label: "Actividades inmobiliarias realizadas a cambio de una retribución o por contrata"
  },
  { value: "6910", label: "Actividades jurídicas" },
  {
    value: "6920",
    label:
      "Actividades de contabilidad, teneduría de libros, auditoría financiera y asesoría tributaria"
  },
  { value: "7010", label: "Actividades de administración empresarial" },
  { value: "7020", label: "Actividades de consultaría de gestión" },
  {
    value: "7110",
    label:
      "Actividades de arquitectura e ingeniería y otras actividades conexas de consultoría técnica"
  },
  { value: "7120", label: "Ensayos y análisis técnicos" },
  {
    value: "7210",
    label:
      "Investigaciones y desarrollo experimental en el campo de las ciencias naturales y la ingeniería"
  },
  {
    value: "7220",
    label:
      "Investigaciones y desarrollo experimental en el campo de las ciencias sociales y las humanidades"
  },
  { value: "7310", label: "Publicidad" },
  { value: "7320", label: "Estudios de mercado y realización de encuestas de opinión pública" },
  { value: "7410", label: "Actividades especializadas de diseño" },
  { value: "7420", label: "Actividades de fotografía" },
  { value: "7490", label: "Otras actividades profesionales, científicas y técnicas n.c.p." },
  { value: "7500", label: "Actividades veterinarias" },
  { value: "7710", label: "Alquiler y arrendamiento de vehículos automotores" },
  { value: "7721", label: "Alquiler y arrendamiento de equipo recreativo y deportivo" },
  { value: "7722", label: "Alquiler de videos y discos" },
  {
    value: "7729",
    label: "Alquiler y arrendamiento de otros efectos personales y enseres domésticos n.c.p."
  },
  {
    value: "7730",
    label: "Alquiler y arrendamiento de otros tipos de maquinaria, equipo y bienes tangibles n.c.p."
  },
  {
    value: "7740",
    label:
      "Arrendamiento de propiedad intelectual y productos similares, excepto obras protegidas por derechos de autor"
  },
  { value: "7810", label: "Actividades de agencias de empleo" },
  { value: "7820", label: "Actividades de agencias de empleo temporal" },
  { value: "7830", label: "Otras actividades de suministro de recurso humano" },
  { value: "7911", label: "Actividades de las agencias de viaje" },
  { value: "7912", label: "Actividades de operadores turísticos" },
  { value: "7990", label: "Otros servicios de reserva y actividades relacionadas" },
  { value: "8010", label: "Actividades de seguridad privada" },
  { value: "8020", label: "Actividades de servicios de sistemas de seguridad" },
  { value: "8030", label: "Actividades de detectives e investigadores privados" },
  { value: "8110", label: "Actividades combinadas de apoyo a instalaciones" },
  { value: "8121", label: "Limpieza general interior de edificios" },
  {
    value: "8129",
    label: "Otras actividades de limpieza de edificios e instalaciones industriales"
  },
  { value: "8130", label: "Actividades de paisajismo y servicios de mantenimiento conexos" },
  { value: "8211", label: "Actividades combinadas de servicios administrativos de oficina" },
  {
    value: "8219",
    label:
      "Fotocopiado, preparación de documentos y otras actividades especializadas de apoyo a oficina"
  },
  { value: "8220", label: "Actividades de centros de llamadas (Call center)" },
  { value: "8230", label: "Organización de convenciones y eventos comerciales" },
  {
    value: "8291",
    label: "Actividades de agencias de cobranza y oficinas de calificación crediticia"
  },
  { value: "8292", label: "Actividades de envase y empaque" },
  { value: "8299", label: "Otras actividades de servicio de apoyo a las empresas n.c.p." },
  { value: "8411", label: "Actividades legislativas de la administración pública" },
  { value: "8412", label: "Actividades ejecutivas de la administración pública" },
  {
    value: "8413",
    label:
      "Regulación de las actividades de organismos que prestan servicios de salud, educativos, culturales y otros servicios sociales, excepto servicios de seguridad social"
  },
  { value: "8414", label: "Actividades reguladoras y facilitadoras de la actividad económica" },
  { value: "8415", label: "Actividades de los otros órganos de control" },
  { value: "8421", label: "Relaciones exteriores" },
  { value: "8422", label: "Actividades de defensa" },
  { value: "8423", label: "Orden público y actividades de seguridad" },
  { value: "8424", label: "Administración de justicia" },
  { value: "8430", label: "Actividades de planes de seguridad social de afiliación obligatoria" },
  { value: "8511", label: "Educación de la primera infancia" },
  { value: "8512", label: "Educación preescolar" },
  { value: "8513", label: "Educación básica primaria" },
  { value: "8521", label: "Educación básica secundaria" },
  { value: "8522", label: "Educación media académica" },
  { value: "8523", label: "Educación media técnica y de formación laboral" },
  { value: "8530", label: "Establecimientos que combinan diferentes niveles de educación" },
  { value: "8541", label: "Educación técnica profesional" },
  { value: "8542", label: "Educación tecnológica" },
  { value: "8543", label: "Educación de instituciones universitarias o de escuelas tecnológicas" },
  { value: "8544", label: "Educación de universidades" },
  { value: "8551", label: "Formación académica no formal" },
  { value: "8552", label: "Enseñanza deportiva y recreativa" },
  { value: "8553", label: "Enseñanza cultural" },
  { value: "8559", label: "Otros tipos de educación n.c.p." },
  { value: "8560", label: "Actividades de apoyo a la educación" },
  { value: "8610", label: "Actividades de hospitales y clínicas, con internación" },
  { value: "8621", label: "Actividades de la práctica médica, sin internación" },
  { value: "8622", label: "Actividades de la práctica odontológica" },
  { value: "8691", label: "Actividades de apoyo diagnóstico" },
  { value: "8692", label: "Actividades de apoyo terapéutico" },
  { value: "8699", label: "Otras actividades de atención de la salud humana" },
  { value: "8710", label: "Actividades de atención residencial medicalizada de tipo general" },
  {
    value: "8720",
    label:
      "Actividades de atención residencial, para el cuidado de pacientes con retardo mental, enfermedad mental y consumo de sustancias psicoactivas"
  },
  {
    value: "8730",
    label:
      "Actividades de atención en instituciones para el cuidado de personas mayores y/o discapacitadas"
  },
  { value: "8790", label: "Otras actividades de atención en instituciones con alojamiento" },
  {
    value: "8810",
    label: "Actividades de asistencia social sin alojamiento para personas mayores y discapacitadas"
  },
  { value: "8890", label: "Otras actividades de asistencia social sin alojamiento" },
  { value: "9001", label: "Creación literaria" },
  { value: "9002", label: "Creación musical" },
  { value: "9003", label: "Creación teatral" },
  { value: "9004", label: "Creación audiovisual" },
  { value: "9005", label: "Artes plásticas y visuales" },
  { value: "9006", label: "Actividades teatrales" },
  { value: "9007", label: "Actividades de espectáculos musicales en vivo" },
  { value: "9008", label: "Otras actividades de espectáculos en vivo" },
  { value: "9101", label: "Actividades de bibliotecas y archivos" },
  {
    value: "9102",
    label: "Actividades y funcionamiento de museos, conservación de edificios y sitios históricos"
  },
  { value: "9103", label: "Actividades de jardines botánicos, zoológicos y reservas naturales" },
  { value: "9200", label: "Actividades de juegos de azar y apuestas" },
  { value: "9311", label: "Gestión de instalaciones deportivas" },
  { value: "9312", label: "Actividades de clubes deportivos" },
  { value: "9319", label: "Otras actividades deportivas" },
  { value: "9321", label: "Actividades de parques de atracciones y parques temáticos" },
  { value: "9329", label: "Otras actividades recreativas y de esparcimiento n.c.p." },
  { value: "9411", label: "Actividades de asociaciones empresariales y de empleadores" },
  { value: "9412", label: "Actividades de asociaciones profesionales" },
  { value: "9420", label: "Actividades de sindicatos de empleados" },
  { value: "9491", label: "Actividades de asociaciones religiosas" },
  { value: "9492", label: "Actividades de asociaciones políticas" },
  { value: "9499", label: "Actividades de otras asociaciones n.c.p." },
  { value: "9511", label: "Mantenimiento y reparación de computadores y de equipo periférico" },
  { value: "9512", label: "Mantenimiento y reparación de equipos de comunicación" },
  { value: "9521", label: "Mantenimiento y reparación de aparatos electrónicos de consumo" },
  {
    value: "9522",
    label: "Mantenimiento y reparación de aparatos y equipos domésticos y de jardinería"
  },
  { value: "9523", label: "Reparación de calzado y artículos de cuero" },
  { value: "9524", label: "Reparación de muebles y accesorios para el hogar" },
  {
    value: "9529",
    label: "Mantenimiento y reparación de otros efectos personales y enseres domésticos"
  },
  {
    value: "9601",
    label: "Lavado y limpieza, incluso la limpieza en seco, de productos textiles y de piel"
  },
  { value: "9602", label: "Peluquería y otros tratamientos de belleza" },
  { value: "9603", label: "Pompas fúnebres y actividades relacionadas" },
  { value: "9609", label: "Otras actividades de servicios personales n.c.p." },
  {
    value: "9700",
    label: "Actividades de los hogares individuales como empleadores de personal doméstico"
  },
  {
    value: "9810",
    label:
      "Actividades no diferenciadas de los hogares individuales como productores de bienes para uso propio"
  },
  {
    value: "9820",
    label:
      "Actividades no diferenciadas de los hogares individuales como productores de servicios para uso propio"
  },
  { value: "9900", label: "Actividades de organizaciones y entidades extraterritoriales" }
];
